import { Locale } from "@redotech/crdb-enums/common/locale";
import { TranslatableInstructionMethodSchema } from "@redotech/redo-return-settings-common/packing-instruction-return-method";
import * as z from "zod";

/**
 * AI drafts of one custom instruction set for the merchant to review and
 * approve. Nothing is stored; locales whose draft failed are absent.
 */
export const draftReturnInstructionTranslations = {
  name: "draftReturnInstructionTranslations" as const,
  input: z.object({
    instructionSet: TranslatableInstructionMethodSchema,
    locales: z.array(z.enum(Locale)).max(20),
  }),
  output: z.object({
    drafts: z.array(
      z.object({ locale: z.enum(Locale), instructions: z.array(z.string()) }),
    ),
  }),
};
